import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c34ab44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading text-center" }, "トレーニングコース詳細", -1))
const _hoisted_2 = { class: "learning-course-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "コース名", -1))
const _hoisted_4 = { class: "grid-content bg-purple-light" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "カテゴリ", -1))
const _hoisted_6 = { class: "grid-content bg-purple-light" }
const _hoisted_7 = { class: "grid-content bg-purple-light" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success fs12" }, "移動", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "解答数", -1))
const _hoisted_10 = { class: "grid-content bg-purple-light" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "正答数", -1))
const _hoisted_12 = { class: "grid-content bg-purple-light" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "正答率", -1))
const _hoisted_14 = { class: "grid-content bg-purple-light" }
const _hoisted_15 = { class: "form-card" }
const _hoisted_16 = { class: "main" }
const _hoisted_17 = { class: "learning-course-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "解答数", -1))
const _hoisted_19 = { class: "grid-content bg-purple-light" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "正答数", -1))
const _hoisted_21 = { class: "grid-content bg-purple-light" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content bg-purple sub-heading" }, "正答率", -1))
const _hoisted_23 = { class: "grid-content bg-purple-light" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-heading" }, "質問", -1))
const _hoisted_25 = { class: "el-card" }
const _hoisted_26 = { class: "el-card__body question-body" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-heading mt20" }, "選択肢", -1))
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "select-edit" }
const _hoisted_31 = { class: "el-card" }
const _hoisted_32 = { class: "el-card__body answer-body" }
const _hoisted_33 = {
  key: 0,
  class: "tag-wrapper"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("正解 ")
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-heading mt20" }, "解説", -1))
const _hoisted_37 = { class: "el-card" }
const _hoisted_38 = { class: "el-card__body commentary-body" }
const _hoisted_39 = ["innerHTML"]

import { useStore } from "vuex";
import { computed } from "vue";
import { LearningForm } from "@/types/learningForm";
import { faPlus, faTimes, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import CategorySelectDialog from '@/components/common/categories/CategorySelectDialog.vue'
import { LearningCategory } from '@/types/learning_category'
interface Props {
  modelValue: { name: string, correct_count: number, answer_count: number };
  categoryName: string;
  learningForms: LearningForm[];
  moveCategoryDialogVisible: boolean;
  learningCategories: LearningCategory[];
}
interface Emits {
  (e: "update:modelValue", value: string): void;
  (e: "update:category", value: LearningCategory): void;
  (e: "update:moveCategoryDialogVisible", visile: boolean): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Object, required: true },
    categoryName: { type: String, required: true },
    learningForms: { type: Array, required: true },
    moveCategoryDialogVisible: { type: Boolean, required: true },
    learningCategories: { type: Array, required: true }
  },
  emits: ["update:modelValue", "update:category", "update:moveCategoryDialogVisible"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: string): void;
  (e: "update:category", value: LearningCategory): void;
  (e: "update:moveCategoryDialogVisible", visile: boolean): void
}), expose: any, slots: any, attrs: any }) {

library.add(faPlus, faTimes, faSortUp, faSortDown);

const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const handleUpdateModelValue = (visible: boolean) => {
  emit('update:moveCategoryDialogVisible', visible);
};
const handleMoveCategory = (v: any) => {
  emit('update:category', v);
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(__props.modelValue.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(__props.categoryName) + " ", 1),
                    _createElementVNode("span", _hoisted_7, [
                      (_unref(managerFlg))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "text",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleUpdateModelValue(true))),
                            class: "height"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(__props.modelValue.answer_count), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(__props.modelValue.correct_count), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(__props.modelValue.answer_count !== 0 ?
            Math.round(__props.modelValue.correct_count / __props.modelValue.answer_count * 1000) / 10 : '-') + "%", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.learningForms, (learningform) => {
          return (_openBlock(), _createElementBlock("div", {
            key: learningform.learning_id,
            class: "questions-and-answers"
          }, [
            _createVNode(_component_el_card, {
              shadow: "never",
              class: "mb20",
              id: 'card_' + learningform.learning_id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 22 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(learningform.answer_count), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 22 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(learningform.correct_count), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 22 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(learningform.answer_count !== 0 ?
                    Math.round(learningform.correct_count / learningform.answer_count * 1000) / 10 : '-') + "%", 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    (_openBlock(), _createElementBlock("div", {
                      key: learningform.id
                    }, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            innerHTML: learningform.question
                          }, null, 8, _hoisted_27)
                        ])
                      ]),
                      _hoisted_28,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learningform.answers, (answer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "question-and-answer-box",
                          key: answer.id
                        }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  (answer.correct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(_component_el_tag, {
                                          type: "success",
                                          class: "tag-redius",
                                          effect: "dark"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_34
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    innerHTML: answer.body
                                  }, null, 8, _hoisted_35)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128)),
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", {
                            innerHTML: learningform.commentary
                          }, null, 8, _hoisted_39)
                        ])
                      ])
                    ]))
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["id"])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(CategorySelectDialog, {
      title: "カテゴリ移動",
      categories: __props.learningCategories,
      modelValue: __props.moveCategoryDialogVisible,
      "onUpdate:modelValue": handleUpdateModelValue,
      onSubmit: handleMoveCategory
    }, null, 8, ["categories", "modelValue"])
  ], 64))
}
}

})